import { StatementType } from "./index.js";
import { isAlterTableAddOnly, isCommaToken, isDefaultValue, isForValue, isLeftParentToken, isNewStatement, isPeriodToken, isRightParentToken, isSemicolonToken, isStringToken, isTableValue } from "../helper.js";
import { isNextValueFor, writeDefaultExpression } from "./default.expression.js";
//#region ../schema-sql-parser/dist/parser/statement/alter.table.add.default.js
function alterTableAddDefaultParser(tokens, $pos, database) {
	const newStatement = isNewStatement(tokens);
	const isSemicolon = isSemicolonToken(tokens);
	const isComma = isCommaToken(tokens);
	const isLeftParent = isLeftParentToken(tokens);
	const isRightParent = isRightParentToken(tokens);
	const isString = isStringToken(tokens);
	const isPeriod = isPeriodToken(tokens);
	const isTable = isTableValue(tokens);
	const isDefault = isDefaultValue(tokens);
	const isFor = isForValue(tokens);
	const nextValueFor = isNextValueFor(tokens);
	const isOnly = isAlterTableAddOnly(tokens)($pos.value);
	const isToken = () => $pos.value < tokens.length;
	const isColumnFor = (pos) => isFor(pos) && !nextValueFor(pos);
	const expressionEnd = (start) => {
		let depth = 0;
		let cursor = start;
		for (; cursor < tokens.length; cursor++) {
			if (isSemicolon(cursor) || newStatement(cursor)) break;
			if (isLeftParent(cursor)) depth++;
			else if (isRightParent(cursor)) {
				if (depth === 0) break;
				depth--;
			} else if (depth === 0 && (isComma(cursor) || isColumnFor(cursor))) break;
		}
		return cursor;
	};
	const ast = {
		type: StatementType.alterTableAddDefault,
		name: "",
		columnName: "",
		default: ""
	};
	let clauseRead = false;
	$pos.value++;
	if (isTable($pos.value)) {
		$pos.value++;
		if (isOnly) $pos.value++;
		if (isString($pos.value)) {
			ast.name = tokens[$pos.value].value;
			$pos.value++;
			while (isPeriod($pos.value) && isString($pos.value + 1)) {
				ast.name = tokens[$pos.value + 1].value;
				$pos.value += 2;
			}
		}
	}
	while (isToken() && !newStatement($pos.value)) {
		if (isSemicolon($pos.value)) {
			$pos.value++;
			break;
		}
		if (!clauseRead && isDefault($pos.value)) {
			const start = $pos.value + 1;
			const end = expressionEnd(start);
			ast.default = writeDefaultExpression(tokens.slice(start, end), database);
			$pos.value = end;
			clauseRead = true;
			if (isFor($pos.value) && isString($pos.value + 1)) {
				ast.columnName = tokens[$pos.value + 1].value;
				$pos.value += 2;
			}
			continue;
		}
		$pos.value++;
	}
	return ast;
}
//#endregion
export { alterTableAddDefaultParser };
